import { render, staticRenderFns } from "./QuanLyDuLieu.vue?vue&type=template&id=7b906999"
import script from "./QuanLyDuLieu.vue?vue&type=script&lang=js"
export * from "./QuanLyDuLieu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports